import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

import config from 'src/config';
import { domain, domainConfig, getPromo } from 'src/helpers/domainConfig';
import api from 'src/actions/api';
import LoginForm from './form';
import ContactForm from './contactForm';
import LoginHeader from './header';
import LoginFooter from './footer';

import { getStorageSid } from 'src/helpers/session';
import './styles.css';

class Login extends React.Component {
  query = {};

  getQuery = () => {
    const loc = this.props.location;
    var query = queryString.parse(loc.search);
    if (loc.state && loc.state.from && loc.state.from.search) {
      query = queryString.parse(loc.state.from.search);
    }
    this.query = query;
    return query;
  };

  checkAutologin() {
    let query = this.getQuery();
    if (
      (typeof query.autologin != 'undefined' || typeof query.autologinid != 'undefined') &&
      query.password &&
      query.id
    ) {
      this.props.api('auth/autologin', {
        id: query.id,
        password: query.password,
        sid: getStorageSid() || false,
      });
      return true;
    }
  }

  componentWillMount() {
    let query = this.getQuery();
    const autologin = this.checkAutologin();
    let sid = getStorageSid();
    if (!autologin && sid && !this.props.keepSid) {
      this.props.api('auth/sid', {
        sid: getStorageSid(),
      });
    }
    const initialState = {
      signup: query.signup || query.aid || query.mid || query.oid || true,
      contacts: false,
      contactForm: false,
    };

    this.setState(initialState);
    document.body.classList.add('white');
    if (domainConfig.backgroundImage) {
      // document.body.style.backgroundImage = `url(${domainConfig.backgroundImage})`
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('white');
    document.body.style.backgroundImage = '';
  }

  toggleSignup = (e) => {
    this.setState({
      signup: !this.state.signup,
      contacts: false,
    });
  };

  toggleContacts = (e) => {
    this.setState({
      contacts: !this.state.contacts,
    });
  };

  getPage() {
    var defaultPage = '/chatsales';
    let role_id = this.props.user.role_id;
    if (role_id >= 2) {
      defaultPage = '/all_stats';
    } else if (role_id == 1) {
      defaultPage = '/chatsales';
    } else {
      defaultPage = '/chatsales';
    }
    if (this.state.signup || this.props.user.offers.length == 0) {
      defaultPage = '/profile';
    }
    var from = (this.props.location.state || {}).from;
    if (from) {
      var route = from.pathname.split('/app/')[1];
      if (!route) {
        from = false;
      }
    }
    if (!from) {
      from = { pathname: config.basePath + defaultPage };
    }
    if (from.search && from.search.indexOf('autologin') != -1) {
      from.search = '';
    }
    if (this.props.lastPage) {
      from = { pathname: this.props.lastPage };
    }
    return from;
  }

  render() {
    if (this.props.logged) return <Redirect to={this.getPage()} />;
    let from = (this.props.location.state || { search: '' }).from;
    console.log('from', this.props.location.state);
    var pageConfig = domainConfig;
    if (from && from.pathname && from.pathname.indexOf('snapchatpromo') != -1) {
      pageConfig = getPromo('snapchatpromo');
    }

    var Content;
    let error =
      this.props.login.error ||
      this.props.signup.error ||
      this.props.autologin.error ||
      this.props.sid.error ||
      this.props.logback.error ||
      this.state.error ||
      '';
    let badCredentials = error.toString() == 'Bad credentials';
    let loading = this.props.autologin.loading || this.props.sid.loading || this.props.logback.loading;

    let { signup, contactForm, contacts } = this.state;

    console.log('pageConfig.title', pageConfig.title);
    return (
      <div class="app">
        <div id="content" class="app-content app-content-login box-shadow-0" role="main">
          <LoginHeader
            pageConfig={pageConfig}
            loading={this.props.sid.loading}
            toggleSignup={this.toggleSignup}
            toggleContacts={this.toggleContacts}
            signupState={signup}
          />
          <div class="content-main " id="content-main">
            {loading && (
              <div class="login-content-container">
                <div>Authenticating...</div>
              </div>
            )}
            {!loading && (
              <div>
                <div
                  class="login-middle-container box-shadow"
                  style={{
                    backgroundImage: `url(${pageConfig.backgroundImage})`,
                  }}
                >
                  <div class="container pt-5 pb-5">
                    <div class="row">
                      {signup && !contacts && (
                        <div class="col-sm-8 text-center">
                          {pageConfig.signupImageTitle && (
                            <div class="signup-image-title">{pageConfig.signupImageTitle}</div>
                          )}
                          <img class="signup-image" src={pageConfig.signupImage} />
                          {pageConfig.signupImageText && (
                            <div class="signup-image-text">{pageConfig.signupImageText}</div>
                          )}
                        </div>
                      )}
                      {contacts && pageConfig.contacts && (
                        <div class="col-sm-8 contacts-info">
                          <div class="box border p-3 login-form-height">
                            {pageConfig.contacts.title && <h3>{pageConfig.contacts.title}</h3>}
                            {pageConfig.contacts.name && (
                              <div class="contacts-text">Name: {pageConfig.contacts.name}</div>
                            )}
                            {pageConfig.contacts.skype && (
                              <div class="contacts-text">Skype: {pageConfig.contacts.skype}</div>
                            )}
                            {pageConfig.contacts.mobile && (
                              <div class="contacts-text">Mobile: {pageConfig.contacts.mobile}</div>
                            )}
                            {pageConfig.contacts.text && (
                              <div class="contacts-text">{pageConfig.contacts.text}</div>
                            )}
                          </div>
                        </div>
                      )}
                      {contacts && !pageConfig.contacts && (
                        <ContactForm toggleContacts={this.toggleContacts} />
                      )}
                      {(!contacts || (contacts && pageConfig.contacts)) && (
                        <div class={'col-sm-4 mx-auto'}>
                          <LoginForm isSignup={signup} query={this.query} />
                          {pageConfig.contacts && (
                            <div class="contact-us text-right" onClick={this.toggleContacts}>
                              Contact US
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  class="pt-4 mb-0 pb-2 login-bottom-container"
                  style={
                    {
                      // minHeight: this.state.signup ? window.innerHeight-600 : window.innerHeight-470
                    }
                  }
                >
                  <div class="container">
                    <div class="row">
                      {pageConfig.columns.map((columnConfig, i) => (
                        <div key={i} class="col-sm">
                          <div class="span3 menu1 no-margin">
                            {columnConfig.type === 'img' ? (
                              <img src={columnConfig.icon} />
                            ) : (
                              <i class={columnConfig.icon}></i>
                            )}
                            &nbsp;{columnConfig.label}
                          </div>
                          <p class="description pr-4">{columnConfig.text}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <LoginFooter
            pageConfig={pageConfig}
            loading={this.props.sid.loading}
            toggleSignup={this.toggleSignup}
            toggleContacts={this.toggleContacts}
            signupState={signup}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  function(state) {
    return {
      logged: !!state.session.user,
      user: state.session.user,
      lastPage: state.session.lastPage,
      login: state.api.auth_login || state.api.initial,
      signup: state.api.auth_signup || state.api.initial,
      autologin: state.api.auth_autologin || state.api.initial,
      sid: state.api.auth_sid || state.api.initial,
      logback: state.api.auth_logback || state.api.initial,
      keepSid: state.session.keepSid,
    };
  },
  { api }
)(Login);
